import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

/**
 * Mobile-only floating back button. Hidden on desktop (md+) and on the home page
 * where there's nothing to go back to. Uses browser history when available so
 * the user lands on the exact previous scroll position; falls back to a sensible
 * parent path when the user landed directly (e.g. from a QR code).
 */
export default function MobileBackButton() {
  const loc = useLocation();
  const nav = useNavigate();

  // Hide on home
  if (loc.pathname === '/' || loc.pathname === '') return null;

  const handleBack = () => {
    // Prefer real history so the user keeps scroll and filters intact.
    if (window.history.length > 1) {
      nav(-1);
      return;
    }
    // Fallback: go to the logical parent path (strip last segment).
    const parts = loc.pathname.replace(/\/$/, '').split('/').filter(Boolean);
    if (parts.length <= 1) {
      nav('/');
    } else {
      nav('/' + parts.slice(0, -1).join('/'));
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Torna indietro"
      className="mobile-back-btn"
      data-testid="mobile-back-btn"
    >
      <ChevronLeft size={22} strokeWidth={2.2} />
    </button>
  );
}
